// TODO QS-10687: Replace with the official third-party logo when available.
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgePioAwsIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-aws-prod" */ './utils').then(
			(m) => m.ForgePioAwsIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-aws-prod/icon' },
);

const LazyForgePioAwsSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-aws-prod-search-result" */ './utils').then(
			(m) => m.ForgePioAwsSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-aws-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgePioAwsIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioAwsIconComponent />
	</Suspense>
);

export const ForgePioAwsSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioAwsSearchResultIconComponent />
	</Suspense>
);
